import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import * as _ from 'lodash';
import { Const } from '../config/const';
import { Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { debug } from 'node:util';

@Injectable()
export class TransformInterceptor implements HttpInterceptor {
  constructor(private router: Router, private nzMessageService: NzMessageService) {
  }

  isAbsPath(url: string) {
    return url.startsWith('http://') || url.startsWith('https://');
  }

  private isVersion3Route(): boolean {
    const path = (this.router.url.split('?')[0] || window.location.pathname);
    const version = path.split('/').filter(Boolean)[1];
    return !!version && version.startsWith('v') && version.length === 2;
  }

  // @ts-ignore
  intercept(req: HttpRequest<any>, next: HttpHandler) {

    let url = req.url;
    // let reqUrl = {
    //   origin: window.location.origin
    // };
    let reqUrl = new URL(url, window.location.origin);
    if (this.isAbsPath(url)) {
      reqUrl = new URL(url);
    }

    const isVersion3 = this.isVersion3Route();
    if (!this.isAbsPath(url)) {
      if (isVersion3) {
        // url = `/${version}/api${url}`;
        url = `/v3/api${url}`;
      } else if (reqUrl.pathname.startsWith('/v3/api')) {
        url = reqUrl.pathname + reqUrl.search;
      } else {
        url = '/api' + url;
      }
    }
    // if (!this.isAbsPath(url) && !url.startsWith('/api') && !url.startsWith('/v2/api')) {
    //   url = '/api' + url;
    // }
    const newReq = req.clone({
      url
    });

    // @ts-ignore
    return next.handle(newReq)
      .pipe(
        // @ts-ignore
        map((res: HttpResponse<any>) => {
          if (reqUrl.origin !== window.location.origin) {
            return res;
          }
          let body = _.get(res, 'body');
          if (!body) {
            body = {};
          }
          const code = _.get(body, 'code');
          if (!code) {
            body.code = 200;
          }

          if (res instanceof HttpResponse) {
            // console.log('resp',  res)
            if (body.code === 500) {
              if (body.errorCode === 401 || body.errorCode === 1035) {
                localStorage.removeItem('token');
                sessionStorage.removeItem('currentUserId');
                // console.log(88888)
                this.nzMessageService.info(body.message);
                this.router.navigate(['/login']);
                return;
              }
            }
          }

          // Ken 2018-07-02 13:34 存在code且不为200, 说明报错
          if (code && code !== 200) {
            if (_.get(body, 'errorCode') === Const.ERROR_CODE.TOKEN_ERROR) {
              localStorage.removeItem('token');
              sessionStorage.removeItem('currentUserId');
              this.router.navigate(['/login']);
            }
            throw body;

          }
          // Ken 2018-07-02 13:59 如果code=200, 则直接取data的数据
          _.set(res, 'body', _.get(body, 'data'));
          return res;
        }),
      );
  }
}
